"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextBusinessDay = exports.getEarliestShipDateRecursive = exports.getEarliestShipDate = exports.USHolidays = exports.CanadaHolidays = void 0;
var moment_timezone_1 = require("moment-timezone");
var moment_1 = __importDefault(require("moment"));
var types_1 = require("../types");
var geo_tz_1 = require("geo-tz");
var LabelHelpers_1 = require("./LabelHelpers");
var HOLIDAY_FORMAT = "YYYY-MM-DD";
// List of Holidays, reference: https://docs.google.com/spreadsheets/d/1DTRz12S7MyB6Ot7CR7x6On7APIeoGwltFqgnbeD44zY/edit#gid=0
exports.CanadaHolidays = new Set([
    "2021-10-11",
    "2021-12-25",
    "2021-12-26",
    "2022-01-01",
    "2022-02-21",
    "2022-04-15",
    "2022-05-23",
    "2022-07-01",
    "2022-08-01",
    "2022-09-05",
    "2022-10-10",
    "2022-12-26",
    "2023-01-02",
    "2023-05-22",
    "2023-07-01",
    "2023-09-04",
    "2023-10-09",
    "2023-12-25",
    "2024-01-01", // New Years Day
]);
exports.USHolidays = new Set([
    "2021-11-25",
    "2021-12-25",
    "2021-12-31",
    "2022-01-01",
    "2022-01-17",
    "2022-02-21",
    "2022-05-30",
    "2022-09-05",
    "2022-11-24",
    "2022-12-26",
    "2023-01-02",
    "2023-05-29",
    "2023-06-19",
    "2023-07-04",
    "2023-09-04",
    "2023-11-23",
    "2023-12-25",
    "2024-01-01", // New Years Day
]);
/**
 * Generates earliest possible ship date given cut off time.
 * @param pickupLocation merchant pickup location
 * @param timezone local timezone (ex: America/Toronto) optional
 */
var getEarliestShipDate = function (pickupLocation, timezone) {
    var cutoffTime = pickupLocation.cutoffTime, processingDays = pickupLocation.processingDays, eligibleShipDays = pickupLocation.eligibleShipDays, country = pickupLocation.contact.address.country;
    var currentTime = timezone ? moment_timezone_1.tz(timezone) : moment_1.default();
    var merchantCutoffTime = timezone
        ? moment_timezone_1.tz(cutoffTime, types_1.DATE_FORMAT.CUT_OFF_TIME, timezone).date(currentTime.date())
        : moment_1.default(cutoffTime, types_1.DATE_FORMAT.CUT_OFF_TIME).date(currentTime.date());
    return exports.getEarliestShipDateRecursive(currentTime, merchantCutoffTime, processingDays, eligibleShipDays, country);
};
exports.getEarliestShipDate = getEarliestShipDate;
var getEarliestShipDateRecursive = function (currentTime, merchantCutoffTime, processingDays, eligibleShipDays, country, requestedTime) {
    if (requestedTime === void 0) { requestedTime = currentTime; }
    if (currentTime.isAfter(merchantCutoffTime, "day")) {
        throw new Error("currentTime cannot be the day after the merchantCutoffTime.");
    }
    // Eligible day check
    var currentDay = currentTime.day();
    var isEligibleShipDay = eligibleShipDays.includes(currentDay);
    // Holiday Check
    var holidays = LabelHelpers_1.countryNameToISO2(country) === types_1.CountryISO2.CANADA
        ? exports.CanadaHolidays
        : exports.USHolidays;
    var isHoliday = holidays.has(currentTime.format(HOLIDAY_FORMAT));
    var startOfNextDay = currentTime.clone().add("1", "days").startOf("day");
    var nextCutoffTime = merchantCutoffTime.clone().add("1", "days");
    if (isEligibleShipDay && !isHoliday) {
        // Cutoff Time
        if (currentTime.isBefore(merchantCutoffTime)
            || (currentTime.isSame(merchantCutoffTime) && currentTime !== requestedTime)) {
            // Processing Time
            if (processingDays === 0) {
                return currentTime.clone().startOf("day");
            }
            else {
                return exports.getEarliestShipDateRecursive(startOfNextDay, // Increment day by one
                nextCutoffTime, processingDays - 1, // Decrease processing days by 1
                eligibleShipDays, country, requestedTime);
            }
        }
        else {
            return exports.getEarliestShipDateRecursive(startOfNextDay, nextCutoffTime, processingDays, eligibleShipDays, country, requestedTime);
        }
    }
    else {
        return exports.getEarliestShipDateRecursive(startOfNextDay, // Increment day by one
        nextCutoffTime, processingDays, eligibleShipDays, country, requestedTime);
    }
};
exports.getEarliestShipDateRecursive = getEarliestShipDateRecursive;
/**
 * Generates next business day given package destination
 * if no destination is provided, gets the next business day based on server timezone and Canadian holidays
 * @param destination package destination address
 */
var getNextBusinessDay = function (destination) {
    var _a, _b;
    var currentTime = moment_1.default();
    if (destination) {
        var timezone = geo_tz_1.find((_a = destination.geocode) === null || _a === void 0 ? void 0 : _a.latitude, (_b = destination.geocode) === null || _b === void 0 ? void 0 : _b.longitude)[0];
        currentTime = moment_timezone_1.tz(timezone);
    }
    var holidays = (destination === null || destination === void 0 ? void 0 : destination.country) === types_1.CountryISO2.USA ? exports.USHolidays : exports.CanadaHolidays;
    var nextDayTime = currentTime.clone().add("1", "days");
    // pass over the weekend days and holidays
    while ([0, 6].includes(nextDayTime.day()) ||
        holidays.has(nextDayTime.format(HOLIDAY_FORMAT))) {
        nextDayTime = nextDayTime.clone().add("1", "days");
    }
    return nextDayTime.clone().startOf("day");
};
exports.getNextBusinessDay = getNextBusinessDay;
//# sourceMappingURL=ShipDateHelpers.js.map